import React from "react";
import { Stack } from "@mui/material";

import { subscriptions, SubscriptionTypeEnum, UserSubscription } from "@store/subscriptions";

import ModalComponent from "@components/modal/Modal.component";
import SubscriptionInfoCard from "@components/card/subscriptions/ProSubscription.card";

interface ProSubscriptionDetailsModalProps {
  handleClose: () => void;
  userSubscriptions: UserSubscription[];
}

const ProSubscriptionDetailsModal = (props: ProSubscriptionDetailsModalProps) => {
  const {handleClose, userSubscriptions} = props;

  return (
    <ModalComponent
      handleClose={handleClose}
      title="Offres « Professionel » en cours"
      titleLeft
      maxWidth="md"
      content={(
        <Stack py="30px" alignItems="center" spacing="20px">
          {userSubscriptions.map((subscription, index) => (
              <SubscriptionInfoCard
                key={`subscription - ${index + 1}`}
                userSubscription={subscription}
                subscription={subscriptions.find((s) => s.type === SubscriptionTypeEnum.PROFESSIONAL)}
              />
            ))}
        </Stack>
      )}
    />
  );
};

export default ProSubscriptionDetailsModal;
